import { ReactElement, useEffect } from 'react';
import { RefreshIcon } from '../../icons/RefreshIcon';

import { useDentistsContext } from '..';
import { Alert } from '@mui/material';
import { useDentistStoreState } from '../../../stores/usePaginação';
import { useTotalClinicDataStore } from '../../../stores/usePaginacao';

interface Props {
  total: number;
}

export default function InfoBox({ total }: Props): ReactElement {
  const { state, city, specialty, plan } = useDentistsContext();
  const setDocList = useDentistStoreState(x => x.setDocList);
  const setTotal = useTotalClinicDataStore(x => x.setTotalClinicData);

  const handleRefresh = async () => {
    if (!state || !city || !specialty) {
      console.warn('Filtros incompletos:', { state, city, specialty });
      return;
    }

    try {
      await fetch(
        `${process.env.REACT_APP_OG_API_URL}/info/RedeVendas?` +
          `ufId=${state.Id}&municipioId=${city.Id}&especialidadeId=${specialty.idEspecialidade}` +
          `&quantidade=5`,
      )
        .then(resp => resp.json())
        .then(data => {
          const c = data.clinicas
            .filter(d => d.longitude)
            .map(d => ({
              ...d,
              longitude: d.longitude.replace(',', '.'),
              latitude: d.latitude.replace(',', '.'),
            }));
          Promise.all(c)
            .then(updatedDentists => {
              setDocList(c || []);
              setTotal(c.total || 0);
            })
            .catch(err => {
              setDocList(c || []);
              setTotal(c.total || 0);
            });
        });
    } catch (err) {
      console.error('Erro ao buscar dados:', err);
    }

    /* fetchData({
      stateId: state.Id,
      cityId: city.Id,
      specialtyId: specialty.idEspecialidade,
    }); */
  };

  return (
    <div className="rounded-lg p-5 mt-5 max-w-[790px] w-full">
      <div className="flex justify-between mt-3 max-[1300px]:flex-col min-[1300px]:items-center gap-8">
        <div className="flex mb-5 gap-3 max-[1300px]:flex-col">
          <img
            className="w-5 h-5 max-[1300px]:w-4 max-[1300px]:h-4"
            src="/assets/images/icons/search.svg"
            alt="Ícone de busca"
          />

          <h2 className="text-1xl font-semibold text-primary-main max-[800px]:text-base">
            Critérios de busca:
          </h2>

          <div>
            <p className="font-bold uppercase text-medium-emphasis text-base max-[800px]:text-sm">
              Região
            </p>
            <p className="text-high-emphasis text-lg max-[800px]:text-sm">
              {(city as any).Nome} - {state.Sigla}
            </p>
          </div>

          <div>
            <p className="font-bold uppercase text-medium-emphasis text-base max-[800px]:text-sm">
              Especialidade
            </p>
            <p className="text-high-emphasis text-lg max-[800px]:text-sm">
              {specialty.nomeEspecialidade}
            </p>
          </div>
          {/* <div>
            <p className="font-bold uppercase text-medium-emphasis text-base">
              Rede Plano
            </p>
            <p className="text-high-emphasis text-1xl">{plan.name}</p>
          </div> */}
        </div>
      </div>

      {/* 
      <div className="flex items-center w-fit mb-5 p-3 rounded-lg bg-neutral-surface shadow-sm gap-2">
        <p className="uppercase text-medium-emphasis text-xs">
          Total de Dentistas encontrados:
        </p>
        <span className="text-high-emphasis font-semibold text-sm bg-primary-container px-2 py-1 rounded">
          {total}
        </span>
      </div>
      */}
      <div
        className="flex flex-wrap sm:flex-nowrap items-center w-full sm:w-fit p-3 rounded-lg bg-neutral-surface shadow-sm gap-x-4 gap-y-2 group cursor-pointer"
        onClick={handleRefresh}
      >
        <p className="uppercase text-medium-emphasis text-[10px] sm:text-xs">
          Dentistas que atendem a sua busca:
        </p>

        <span className="text-high-emphasis font-semibold text-[11px] sm:text-sm bg-primary-container px-2 py-1 rounded">
          {total}
        </span>

        {total > 5 && (
          <div className="flex items-center gap-2">
            <p className="text-[11px] sm:text-sm">
              Atualize sua lista de Dentista
            </p>
            <button className="p-2 rounded hover:bg-gray-200 transition">
              <RefreshIcon />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
